import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { Link, useHistory } from "react-router-dom";
import { ArrowLongLeftIcon } from '@heroicons/react/24/solid';
import './../../styles/styles.css'
import axios from "axios";
import { useAlert } from "react-alert";


const EditUser = () => {

    let { id } = useParams();
    const userid = atob(id);

    const [userData, setUserData] = useState("");
    const [userName, setUserName] = useState("");
    const [userRole, setUserRole] = useState("");
    const [userBDay, setUserBDay] = useState("");
    const [userJDay, setUserJDay] = useState("");
    const [userJobTitle, setUserJobTitle] = useState("");
    const [userManager, setUserManager] = useState("");
    const [userTeam, setUserTeam] = useState("");
    const [errors, setErrors] = useState({});
    const alert = useAlert();
    const history = useHistory();

    useEffect(() => {
        axios({
            url: process.env.REACT_APP_API_URL + "api/user/" + userid,
            method: "GET",
        })
            .then((res) => {
                if (res.data.issuccessful) {
                    setUserData(res.data.user);
                    setUserName(res.data.user.UserName);
                    setUserRole(res.data.user.AppRole);
                    setUserBDay(res.data.user.birth_date);
                    setUserJDay(res.data.user.joining_date);
                    setUserJobTitle(res.data.user.JobTitle);
                    setUserManager(res.data.user.Manager);
                    setUserTeam(res.data.user.UserTeam);
                }
            })

            // Catch errors if any
            .catch((err) => {
                console.error('There was an error!', err);
            });

    }, [])

    const calculateDifference = (startDate, endDate) => {
        const startYear = startDate.getFullYear();
        const endYear = endDate.getFullYear();
        const yearDiff = endYear - startYear;

        if (endDate < new Date(endYear, startDate.getMonth(), startDate.getDate())) {
            return yearDiff - 1;
        }

        return yearDiff;
    }


    const handleSubmit = (event) => {
        event.preventDefault();

        const err = {};
        const pattern = /^[a-zA-Z\s]+$/;

        const startDate = new Date(userBDay)
        const endDate = new Date(userJDay)

        const differenceInYears = calculateDifference(startDate, endDate);

        if (!userName) {
            err.userName = 'Name is required';
        }

        if (userName && !pattern.test(userName)) {
            err.userName = 'Only alphabets and space is allowed';
        }

        if (!userBDay) {
            err.userBDay = 'Birth Date is required';
        }

        if (!userRole) {
            err.userRole = 'Role is required';
        }

        if (!userJDay) {
            err.userJDay = 'Joining Date is required';
        }

        if (!userJobTitle) {
            err.userJobTitle = 'Job title is required';
        }

        if (userJobTitle && userJobTitle.length < 6) {
            err.userJobTitle = 'Job title should be minimum of 6 characters';
        }

        if (userJobTitle && !pattern.test(userJobTitle)) {
            err.userJobTitle = 'Only alphabets and space is allowed';
        }

        if (!userManager) {
            err.userManager = 'Manager name is required';
        }

        if (userManager && !pattern.test(userManager)) {
            err.userManager = 'Only alphabets and space is allowed';
        }

        if (!userTeam) {
            err.userTeam = 'Team name is required';
        }

        if (userTeam && !pattern.test(userTeam)) {
            err.userTeam = 'Only alphabets and space is allowed';
        }

        setErrors(err);

        if (Object.keys(err).length === 0) {
            if (differenceInYears < 18) {
                alert.error('Minimum age must be 18 years')
            } else {
                axios.post(process.env.REACT_APP_API_URL + "api/user/updatedetails", {
                    userid,
                    userName,
                    userRole,
                    userBDay,
                    userJDay,
                    userJobTitle,
                    userManager,
                    userTeam
                })
                    .then(function (response) {
                        if (response.data.issuccessful) {
                            alert.success(response.data.message)
                            setTimeout(() => {
                                history.push('/admin/user-management')
                            }, 1500)
                        } else {
                            alert.error(response.data.message)
                        }
                    })
                    .catch(function (error) {
                        alert.error(error);
                    });
            }

        }



    }

    return (
        <div style={{ position: "relative" }} className="rewardRequest">
            <Link to="/admin/user-management" className='admin-header'>
                <ArrowLongLeftIcon className="" style={{ width: '30px' }} />
                <p style={{ marginBottom: '0' }} >Edit User</p>
                <p>{ }</p>
            </Link>

            <form onSubmit={handleSubmit} className='edit-user-form'>
                <p>User Details</p>
                <div className='user-form-div'>
                    <div>
                        <label htmlFor='name'>Name<span style={{ color: 'red' }}>*</span></label>
                        <input type="text" id="name" placeholder='Enter name' defaultValue={userData.UserName} onChange={e => setUserName(e.target.value)} onInput={e => setUserName(e.target.value)} />
                        {errors.userName && (
                            <p className='error-Msg'>{errors.userName}</p>
                        )}
                    </div>
                    <div>
                        <label htmlFor='email'>Work Email<span style={{ color: 'red' }}>*</span></label>
                        <input type="text" id="email" placeholder='Enter work email' value={userData.UserEmail} disabled />
                    </div>
                </div>

                <div className='user-form-div'>
                    <div>
                        <label htmlFor='bday'>Birth Date<span style={{ color: 'red' }}>*</span></label>
                        <input type="date" id="bday" defaultValue={userData.birth_date} onChange={e => setUserBDay(e.target.value)} onInput={e => setUserBDay(e.target.value)} />
                        {errors.userBDay && (
                            <p className='error-Msg'>{errors.userBDay}</p>
                        )}
                    </div>
                    <div>
                        <label htmlFor='role' placeholder=''>Access Role<span style={{ color: 'red' }}>*</span></label>
                        <select name='role' value={userRole} onChange={e => setUserRole(e.target.value)} onInput={e => setUserRole(e.target.value)}>
                            <option value="Admin">Admin</option>
                            <option value="Member">Employee</option>
                        </select>
                        {errors.userRole && (
                            <p className='error-Msg'>{errors.userRole}</p>
                        )}
                    </div>
                </div>

                <div className='user-form-div'>
                    <div>
                        <label htmlFor='joiningday'>Joining Date<span style={{ color: 'red' }}>*</span></label>
                        <input type="date" id="joiningday" defaultValue={userData.joining_date} onChange={e => setUserJDay(e.target.value)} onInput={e => setUserJDay(e.target.value)} />
                        {errors.userJDay && (
                            <p className='error-Msg'>{errors.userJDay}</p>
                        )}
                    </div>
                    <div>
                        <label htmlFor='designation' placeholder=''>Designation<span style={{ color: 'red' }}>*</span></label>
                        <input type="text" id="designation" placeholder='Enter user designation' defaultValue={userData.JobTitle} onChange={e => setUserJobTitle(e.target.value)} onInput={e => setUserJobTitle(e.target.value)} />
                        {errors.userJobTitle && (
                            <p className='error-Msg'>{errors.userJobTitle}</p>
                        )}
                    </div>
                </div>

                <div className='user-form-div'>
                    <div>
                        <label htmlFor='manager'>Manager<span style={{ color: 'red' }}>*</span></label>
                        <input type="text" id="manager" placeholder='Enter user manager' defaultValue={userData.Manager} onChange={e => setUserManager(e.target.value)} onInput={e => setUserManager(e.target.value)} />
                        {errors.userManager && (
                            <p className='error-Msg'>{errors.userManager}</p>
                        )}
                    </div>
                    <div>
                        <label htmlFor='team' placeholder=''>Team<span style={{ color: 'red' }}>*</span></label>
                        <input type="text" id="team" placeholder='Enter user Team' defaultValue={userData.UserTeam} onChange={e => setUserTeam(e.target.value)} onInput={e => setUserTeam(e.target.value)} />
                        {errors.userTeam && (
                            <p className='error-Msg'>{errors.userTeam}</p>
                        )}
                    </div>
                </div>

                <div>
                    <Link to="/admin/user-management" className='issue-btn' style={{ marginRight: '20px' }}>Cancel</Link>
                    <input type='submit' value="Save" className='issue-btn' style={{ marginTop: "20px" }} />
                </div>

            </form >
        </div >
    )
}

export default EditUser